<template>
  <div id="PictureCreate">
    <!-- success msg component 
      <Success :msg="msg" v-show="success" />
      <ProductForm :user="user" @submit-form="saveUser" hasCustomer=true buttonText="Guardar" />
     -->
    <PictureForm :hasValorID="hasValorID" :submitForm="addRow" buttonText="Guardar" hasReset=true hasCarCreate=true />
  </div>
</template>

<script>
import{ mapMutations,mapState } from "vuex";
import PictureForm from "@/components/PictureForm";
//import Success from "./Success";
// import baseApi from '@/services/baseApi';
import icheckApi from '@/services/icheckApi';
// import router from '@/router';

export default {
  name: "PictureCreate",
  computed:{
    ...mapState(['currentUser']),    
  },
  components: {
    PictureForm,
    //Success,
  },
  props: {
    user: Object,
    hasValorID: Number,
  },
  data() {
    return {
      success: false,
      msg: "",
    };
  },
  mounted(){
    console.log("Montado Picture Create");     
    console.log("Create AUTO ID "+this.hasValorID);    
  },
  methods: {
    ...mapMutations(["showLoading","hiddenLoading","changeBreadcrumbs"]),
    async addRow(ProductInfo){
      this.showLoading({titulo:"Almacenando información",color:"warning"})
      console.log(JSON.stringify(ProductInfo));
      // console.log('Row '+ProductInfo[1].fullcar_id)
      let picturesfullcar=ProductInfo;
      try{         
        // let branch_id=this.currentUser.branch_id;
        // let sku=ProductInfo.sku;
        // let modelo=ProductInfo.modelo;
        // let clave_sat=ProductInfo.clave_sat;
        // let brand_id=ProductInfo.brand_id;
        // let prodcategory_id=ProductInfo.prodcategory_id;
        // let ctonline_id=ProductInfo.ctonline_id;
        // let syscom_id=ProductInfo.syscom_id;
        // let syscom=ProductInfo.syscom;
        // let stock_syscom=ProductInfo.stock_syscom;
        // let line_id=ProductInfo.line_id;        
        // let description=ProductInfo.description;    
        // let measurement_id=ProductInfo.measurement_id;        
        // let canasta_basica=ProductInfo.canasta_basica;        
        // let filename=ProductInfo.filename;        
        // let type_article=ProductInfo.type_article;
        // let notes=ProductInfo.notes;     
        // let famcategory_id=ProductInfo.famcategory_id;
        // let subfamily_id=ProductInfo.subfamily_id;
        // let price=ProductInfo.price;    
        // let supplier_id='1';
        // let warehouse_id='1';
        // let iva='';
        // let iva_referencia='';            
        // const { id, branch_id, supplier_id, warehouse_id, product_id, famcategory_id, price,iva,iva_referencia } = this;
        await icheckApi().post(`/autos/picture/create`,JSON.stringify({ picturesfullcar })).then((response)=>{       
            if(!response.data.error){                            
              this.$swal("Genial!",response.data.message, "success");
            }else{
              // this.$swal("Error!",response.data.message, "error");
              this.$swal("Error!",response.data.message+': <br/>'+JSON.stringify(response.data.validate), "error"); 
            }                                    
          });
      }catch(error){
        this.$swal("Error!", "Algo salio mal, Intente nuevamente <br/>"+error, "error");        
      }  finally{
        this.hiddenLoading()
      }
    },
  },
};
</script>